import clsx from "clsx";
import React from "react";
import { Input as CatalystInput } from "../catalyst/input";

// CatalystInput에서 지원하는 input 타입
type SupportedInputType = "text" | "email" | "password" | "tel" | "url" | "number" | "search";

interface InputProps {
  type?: SupportedInputType;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  maxLength?: number;
  name?: string;
  id?: string;
  autoComplete?: string;
  autoFocus?: boolean;
}

const Input: React.FC<InputProps> = ({
  type = "text",
  placeholder,
  value,
  onChange,
  onKeyPress,
  className = "",
  disabled = false,
  fullWidth = false,
  maxLength,
  name,
  id,
  autoComplete,
  autoFocus,
}) => {
  const widthClass = fullWidth ? "w-full" : "";

  return (
    <CatalystInput
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyPress={onKeyPress}
      disabled={disabled}
      maxLength={maxLength}
      name={name}
      id={id}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      className={clsx(widthClass, className)}
    />
  );
};

export default Input;
